<template>
  <div class="main-page">
    <panelify
      extName="Panelify-demo"
      appName="AEFT"
      src="https://zealous-franklin-1d29ab.netlify.com/#/"
      width="340px"
      height="400px"
      :gradient="0"
    />
  </div>
</template>

<script>
import { panelify } from "@inventsable/panelify";

export default {
  components: {
    panelify
  }
};
</script>

<style>
.main-page {
  /* padding: 10px; */
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 96vw;
  width: 100%;
  height: 100%;
  max-height: 96vh;
}
</style>
